import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Link } from '../../interfaces/link.interface';
import { LinkService } from '../../services/link.service';
import { LinkLogComponent } from '../../link/link-log/link-log.component';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-shell-admin-link-log-modal-wrapper',
    templateUrl: './admin-link-log-modal-wrapper.component.html',
    styleUrls: ['./admin-link-log-modal-wrapper.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, LinkLogComponent, AsyncPipe]
})
export class AdminLinkLogModalWrapperComponent implements OnInit {

  linkId: number;

  public title: string = "Admin log viewer"
  public visibleSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)
  public linkSubject: Observable<Link> = new Observable<Link>();

  constructor(private linkService: LinkService) { }

  ngOnInit(): void {
    console.log(this.linkId)
  }

  close() {
    this.visibleSubject.next(false)
    this.linkId = undefined;
  }

  open(linkId: number) {
    this.linkId = linkId;
    this.visibleSubject.next(true);
    console.log(this.linkId)
    this.linkSubject = this.linkService.get(linkId);
  }

}
